// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"11bf06ed","128":"11bf06ed","506":"11bf06ed","663":"11bf06ed","744":"11bf06ed","779":"11bf06ed","952":"11bf06ed"}[chunkId] + ".chunk.css";
};